import { render, staticRenderFns } from "./MitMyAccountPage.vue?vue&type=template&id=0b559dc6&scoped=true"
import script from "./MitMyAccountPage.vue?vue&type=script&lang=js"
export * from "./MitMyAccountPage.vue?vue&type=script&lang=js"
import style0 from "./MitMyAccountPage.vue?vue&type=style&index=0&id=0b559dc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b559dc6",
  null
  
)

export default component.exports